import React, { useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import marquisLogo from "./../../assets/img/collection-inner/marquis-logo.svg";
import paymentIcon1 from "./../../assets/img/collection-inner/payment-icon1.svg";
import paymentIcon2 from "./../../assets/img/collection-inner/payment-icon2.svg";
import paymentIcon3 from "./../../assets/img/collection-inner/payment-icon3.svg";
import dollarGold from "./../../assets/img/collection-inner/dollar-gold.svg";  
import SwiperCore, { Navigation, Pagination, Autoplay } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import LazyLoad from "react-lazyload";

import * as apiUrl from "../../apiUrl";

SwiperCore.use([Navigation, Autoplay, Pagination]);

function CollectionInnerPayments({ paymentPlans, paymentSectionBgImage }) {
  const paymentPlansslides = paymentPlans.slides
    ? JSON.parse(paymentPlans.slides)
    : [];

  return (
    <section className="collection-payment-sec"
      style={{
        backgroundImage: `url(${apiUrl.apiUrl + `/` + paymentSectionBgImage
          })`,
      }}>
      <Container fluid>
        <Row className="banner-text-center">
          <Col md={12}>
            <div className="heading-div">
              <h2 className="common-head whiteColor" data-aos="fade-up">
                {paymentPlans.title}
              </h2>
            </div>
          </Col>
        </Row>
      </Container>
      <Container
        fluid
        className="collection-payment-swiper-div"
        data-aos="fade-up"
      >
        <Row>
          <Col md={12}>
            <Swiper
              className="collection-payment-swiper"
              modules={[Navigation, Pagination]}
              pagination={true}
              navigation={false}
              spaceBetween={40}
              slidesPerView={1}
              speed={1000}
              grabCursor={true}
              draggable={true}
              centeredSlides={false}
              loop={true}
              autoplay={false}
              breakpoints={{
                200: {
                  slidesPerView: 1,
                },
                320: {
                  slidesPerView: 1,
                },
                768: {
                  slidesPerView: 1,
                  spaceBetween: 40,
                },
                992: {
                  slidesPerView: 1,
                  spaceBetween: 40,
                },
                1024: {
                  slidesPerView: 1,
                  spaceBetween: 40,
                },
                1280: {
                  slidesPerView: 1,
                  spaceBetween: 40,
                },
                1920: {
                  slidesPerView: 1,
                  spaceBetween: 40,
                },
                3840: {
                  slidesPerView: 1,
                  spaceBetween: 40,
                },
              }}
            >
              {paymentPlansslides.map((paymentPlansslide, index) => (
                <SwiperSlide>
                  <Row className="banner-text-center">
                    <Col md={12}>
                      <div className="heading-div">
                        <div className="img-div mb-2">
                          <LazyLoad>
                            <img
                              className="img-fluid"
                              src={marquisLogo}
                              alt="Luxury real estate Developer Dubai"
                            />
                          </LazyLoad>
                        </div>
                        <h3 className="common-head goldenColor mb-2">
                          {paymentPlans.sub_title}
                        </h3>
                        {/* <h3 className="common-head goldenColor mb-2">
                          Luxury apartments starting from <span className="dollar-gold-svg-icon">
                            <img src={dollarGold} className="img-fluid" /></span>1.1 million 
                        </h3> */}
                        <p className="rounded-para mb-2">
                          {paymentPlansslide.description}
                        </p>
                      </div>
                    </Col>
                  </Row>
                  <Row className="mt-3 payment-slide-row">
                    {paymentPlansslide.titles.map((title, idx) => (
                      <Col md={4} key={idx}>
                        <div className="collection-payment-swiper-card">
                          <LazyLoad>
                            <img
                              className="img-fluid"
                              src={`${apiUrl.apiUrl}/${paymentPlansslide.images[idx]}`}
                              alt={`Apartments for sale in Dubai`}
                            />
                          </LazyLoad>
                          <p className="common-para">{title}</p>
                        </div>
                      </Col>
                    ))}
                  </Row>
                </SwiperSlide>
              ))}
            </Swiper>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default CollectionInnerPayments;
